import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentEditFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H8l-5 5V5Zm16.5 3.2-1.336 1.336-2.2-2.2L17.3 6l2.2 2.2Zm-4.164-.236 2.2 2.2L10.7 17H8.5v-2.2l6.836-6.836Z"
    />
  </svg>
);
export default IconCommentEditFilledSizeL;
